<template>
  <div>
    <multiselect
      class="multiselect-project"
      v-model="selectedProject"
      :options="filteredProjects"
      :placeholder="resolvedPlaceholder"
      :disabled="disabled"
      :allow-empty="allowEmpty"
      track-by="number"
      :deselectLabel="$t('deselectLabel')"
      selectLabel=""
      selectedLabel=""
      :internal-search="false"
      :show-labels="true"
      @open="onProjectDropdownOpen"
      @search-change="onProjectSearch"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div v-if="option">
          #{{ option.number.toString().padStart(4, '0') }} - {{ option.customer.lastname }},
          {{ option.customer.firstname }}
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div>
          #{{ option.number.toString().padStart(4, '0') }}: {{ option.customer.lastname }},
          {{ option.customer.firstname }}
        </div>
        <div>
          {{ option.customer.street }} {{ option.customer.streetNumber
          }}<span v-if="option.customer.streetNumberSuffix">{{
            option.customer.streetNumberSuffix
          }}</span
          >, {{ option.customer.zip }}
          {{ option.customer.city }}
        </div>
      </template>
      <template slot="noResult">
        <div>{{ $t('no_results') }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

const createProjectsFilter = () => {
  return {
    pagination: {
      page: 0,
      rowsPerPage: 25,
    },
    sortField: 'number',
    sortOrder: -1,
    filters: {
      number: { value: null },
      customerLastname: { value: null },
      customerFirstname: { value: null },
      projectCustomerSearch: { value: null },
    },
  };
};

export default {
  components: {
    Multiselect,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  model: {
    prop: 'project',
    event: 'select',
  },
  data() {
    return {
      filteredProjects: [],
      projectsFilter: createProjectsFilter(),
    };
  },
  computed: {
    ...mapGetters(['getProjects']),
    selectedProject: {
      get() {
        return this.project;
      },
      set(project) {
        this.$emit('select', project);
      },
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('search');
    },
  },
  methods: {
    ...mapActions(['fetchProjectsPaginated']),
    ensureSelectedProjectIsAvailable() {
      if (!this.project) {
        return;
      }

      const hasSelectedProject = this.filteredProjects.some(
        (filteredProject) => filteredProject.number === this.project.number
      );

      if (!hasSelectedProject) {
        this.filteredProjects = [this.project, ...this.filteredProjects];
      }
    },
    async onProjectSearch(rawQuery) {
      const query = rawQuery ? rawQuery.toLowerCase() : null;
      this.projectsFilter.filters.projectCustomerSearch.value = query;
      await this.loadProjectData();
    },
    async onProjectDropdownOpen() {
      await this.loadProjectData();
    },
    async loadProjectData() {
      await this.fetchProjectsPaginated({
        page: this.projectsFilter.pagination.page,
        pageSize: this.projectsFilter.pagination.rowsPerPage,
        sortField: this.projectsFilter.sortField,
        sortOrder: this.projectsFilter.sortOrder,
        filters: { ...this.projectsFilter.filters },
      });

      this.filteredProjects = [...this.getProjects];
      this.ensureSelectedProjectIsAvailable();
    },
  },
  watch: {
    project() {
      this.ensureSelectedProjectIsAvailable();
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect__content-wrapper {
  position: absolute;
}

.multiselect-project {
  position: relative;
}
</style>
